/** @format */

'use client';

// import { useRouter } from "next/navigation";
import { useSearchParams } from 'src/hooks/use-search-params';
// import { zodResolver } from "@hookform/resolvers/zod";
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import { Avatar, Box, Dialog, DialogActions, LinearProgress, Typography } from '@mui/material';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useZaloLoginMutation } from 'src/api/zalo-api';
import { DialogContentStyled, DialogTitleWithButtonClose } from 'src/components/modals';
import { userRoles } from 'src/config';
import { useAuth } from 'src/hooks/use-auth';
import { useCleanUrl } from 'src/hooks/use-clean-url';
import { usePathname } from 'src/hooks/use-pathname';
import { selectCancelRequireZaloPermission, setCancelRequireZaloPermission } from 'src/store/app-slice';

const ZaloRequestPermission = ({ onGetZaloPermission }) => {
  const dispatch = useDispatch();

  const handleClose = useCallback(() => {
    dispatch(setCancelRequireZaloPermission(true));
  }, []);

  return (
    <Dialog
      open={true}
      onClose={(_event, reason) => {
        if (reason !== 'backdropClick') {
          handleClose();
        }
      }}
    >
      <DialogTitleWithButtonClose title="Yêu cầu ủy quyền từ Zalo Official Account" sx={{ pr: 10 }} />

      <DialogContentStyled>
        <Typography variant="body1">Để thực hiện được các tính năng thông báo qua zalo OA, vui lòng xác nhận ủy quyền từ zalo.</Typography>
      </DialogContentStyled>
      <DialogActions
        sx={{
          justifyContent: 'space-around'
        }}
      >
        <Stack direction="row" columnGap={1}>
          <Button variant="contained" color="inherit" onClick={handleClose}>
            Bỏ qua
          </Button>

          <Button variant="contained" color="info" onClick={onGetZaloPermission}>
            Chuyển đến Zalo OA
          </Button>
        </Stack>
      </DialogActions>
      {/* </form> */}
    </Dialog>
  );
};

const ZaloPermissionResponse = ({ code, onGetZaloPermission }) => {
  const navigate = useNavigate();

  const pathname = usePathname();

  const [isLoading, setIsLoading] = useState(true);

  const [zaloLogin, { error }] = useZaloLoginMutation();

  const handleLoginZalo = useCallback(
    async (code) => {
      try {
        const response = await zaloLogin({
          code
        }).unwrap();

        console.log('response', response);
      } finally {
        // catch (error) {
        //   // processError(error);
        // }
        setIsLoading(false);
      }
    },
    [pathname]
  );
  const handleClose = useCallback(() => {
    if (code) {
      navigate(pathname);
    }
  }, [code]);

  useEffect(() => {
    handleLoginZalo(code);
  }, [code]);

  console.log('errorerrorerror', error);
  return (
    <Dialog
      open={true}
      onClose={(_event, reason) => {
        if (reason !== 'backdropClick') {
          handleClose();
        }
      }}
    >
      {/* <DialogTitleWithButtonClose title="Zalo Official Account" sx={{ pr: 10 }} /> */}

      <DialogContentStyled>
        <Stack justifyContent="center" alignItems="center" rowGap={2} py={2}>
          <Avatar
            src={'/assets/zalo_oa.jpg'}
            sx={{
              height: 120,
              width: 120
            }}
          />

          {isLoading ? (
            <Box sx={{ width: '80%' }}>
              <LinearProgress />
            </Box>
          ) : error ? (
            <Typography variant="h6" color="error.main">
              Ủy quyền không thành công !!!
            </Typography>
          ) : (
            <Typography variant="h6" color="primary.main">
              Ủy quyền thành công !!!
            </Typography>
          )}
        </Stack>
      </DialogContentStyled>
      <DialogActions
        sx={{
          justifyContent: 'space-around'
        }}
      >
        <Stack direction="row" columnGap={1}>
          <Button variant="contained" color="inherit" onClick={handleClose}>
            Đóng
          </Button>
          {error && (
            <Button variant="contained" color="info" onClick={onGetZaloPermission}>
              Thử lại
            </Button>
          )}
        </Stack>
      </DialogActions>
      {/* </form> */}
    </Dialog>
  );
};

export const ZaloPermission = () => {
  const {
    user: { zPermissionRequire, role }
  } = useAuth();

  const searchParams = useSearchParams();
  const getCleanUrl = useCleanUrl(['code', 'oa_id']);
  const zaloCode = searchParams.get('code');
  const zaloOaId = searchParams.get('oa_id');
  const cancelRequireZaloPermission = useSelector(selectCancelRequireZaloPermission);

  const handleGetZaloPermission = useCallback(
    debounce(() => {
      const cleanUrl = getCleanUrl();
      const redirectUri = encodeURIComponent(`${window.location.origin}${cleanUrl}`);
      const zaloAuthUrl = `${process.env.REACT_APP_ZALO_BASE_URL}/permission?app_id=${process.env.REACT_APP_ZALO_APP_ID}&redirect_uri=${redirectUri}`;
      window.location.href = zaloAuthUrl;
    }, 200),
    [getCleanUrl]
  );

  if (![userRoles.nhieu_xe, userRoles.owner].includes(role)) {
    return null; // Không render nếu không có quyền
  }

  const shouldShowZaloRequest = zPermissionRequire === true && cancelRequireZaloPermission === false;
  const shouldShowZaloResponse = zaloCode && zaloOaId;

  return (
    <>
      {!shouldShowZaloResponse && shouldShowZaloRequest && <ZaloRequestPermission onGetZaloPermission={handleGetZaloPermission} />}
      {shouldShowZaloResponse && <ZaloPermissionResponse code={zaloCode} onGetZaloPermission={handleGetZaloPermission} />}
    </>
  );
};
export default ZaloPermission;
